import './footer.css';

// Footer — Zenkai. Marca + 4 columnas de navegación + redes + barra inferior.
// Fiel al Footer.dc.html (mismos links, redes y textos legales).

const COLS = [
  { title: 'Academias', links: [
    ['Especialízate', '#especializate'],
    ['Pensamiento de Negocio', '#pensamiento-negocio'],
    ['Habilidades Suaves', '#habilidades-suaves'],
    ['Inglés para Ingenieros', '#ingles'],
  ] },
  { title: 'Plataforma', links: [
    ['Cursos y certificaciones', '#cursos'],
    ['Plantillas y formatos', '#plantillas'],
    ['Comunidad', '#comunidad'],
    ['Asesoría en vivo', '#asesoria'],
    ['App móvil', '#app'],
    ['Planes y precios', '#planes'],
  ] },
  { title: 'Zenkai', links: [
    ['El método', '#metodo'],
    ['Julio Pasos', '#julio'],
    ['Expertos', '#expertos'],
    ['Historias', '#historias'],
    ['Podcast Inge Chingón', '#podcast'],
    ['Para empresas', '#empresas'],
  ] },
  { title: 'Cuenta', links: [
    // Al panel NUEVO, y con las rutas en inglés que son las que existen allí:
    // las españolas de `admin` pintan "Not Found" en panel (comprobado
    // renderizándolas; devuelve 200 a todo por ser una SPA con comodín).
    ['Iniciar sesión', 'https://panel.zenkai.com.mx/auth/login'],
    ['Registrarme', 'https://panel.zenkai.com.mx/auth/sign-up?step=plan'],
    ['Soporte', '#soporte'],
    ['Contacto', '#contacto'],
    ['Agenda una demo', '#demo'],
  ] },
];

const SOCIAL = [
  ['Spotify', 'https://open.spotify.com/show/7HMUJJX8fj12rqvFlSIlQx',
    '<svg width="17" height="17" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2a10 10 0 100 20 10 10 0 000-20zm4.6 14.4a.78.78 0 01-1.07.26c-2.93-1.79-6.62-2.2-10.97-1.2a.78.78 0 11-.35-1.52c4.76-1.09 8.85-.62 12.13 1.39.37.23.49.71.26 1.07zm1.23-2.74a.97.97 0 01-1.34.32c-3.35-2.06-8.46-2.66-12.42-1.45a.97.97 0 11-.57-1.86c4.53-1.37 10.16-.7 14.01 1.66.46.28.6.88.32 1.33zm.11-2.86C14.13 8.42 7.7 8.2 4.27 9.24a1.17 1.17 0 01-.68-2.23c3.94-1.2 11.04-.94 15.4 1.65a1.17 1.17 0 01-1.19 2.01z"/></svg>'],
  ['YouTube', 'https://www.youtube.com/@juliopasosoficial',
    '<svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M21.6 7.2a2.5 2.5 0 00-1.76-1.77C18.25 5 12 5 12 5s-6.25 0-7.84.43A2.5 2.5 0 002.4 7.2C2 8.8 2 12 2 12s0 3.2.4 4.8a2.5 2.5 0 001.76 1.77C5.75 19 12 19 12 19s6.25 0 7.84-.43a2.5 2.5 0 001.76-1.77C22 15.2 22 12 22 12s0-3.2-.4-4.8zM10 15.2V8.8l5.2 3.2-5.2 3.2z"/></svg>'],
  ['TikTok', 'https://www.tiktok.com/@zenkailat',
    '<svg width="17" height="17" viewBox="0 0 24 24" fill="currentColor"><path d="M20.5 7.9a5.9 5.9 0 01-3.6-1.2 5.9 5.9 0 01-2.2-3.3c-.1-.4-.1-.8-.1-1.2h-3.3v12.2c0 .4 0 .8-.1 1.1a2.6 2.6 0 01-4.7 1 2.6 2.6 0 013.3-3.9v-3.4a6 6 0 00-4.6 1.4 6 6 0 00-1.3 7.4 6 6 0 0010.7-.6c.4-.9.5-1.9.5-2.9V8.6a9.2 9.2 0 005.4 1.7V7.9z"/></svg>'],
  ['Instagram', 'https://www.instagram.com/zenkailat',
    '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9"><rect x="3" y="3" width="18" height="18" rx="5"/><circle cx="12" cy="12" r="3.6"/><circle cx="17.2" cy="6.8" r="1" fill="currentColor" stroke="none"/></svg>'],
  ['LinkedIn', 'https://www.linkedin.com/company/zenkailat',
    '<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M4.98 3.5a2.5 2.5 0 100 5 2.5 2.5 0 000-5zM3 9h4v12H3zM9 9h3.8v1.7h.05A4.2 4.2 0 0116.6 8.7c3 0 4.4 1.9 4.4 5.1V21h-4v-6c0-1.5-.5-2.5-1.9-2.5-1.1 0-1.8.75-2.1 1.5-.1.25-.1.6-.1 1V21H9z"/></svg>'],
];

function colHTML(c) {
  const links = c.links.map(([label, href]) => {
    const ext = href.startsWith('http');
    return `<a href="${href}"${ext ? ' target="_blank" rel="noopener"' : ''}>${label}</a>`;
  }).join('');
  return `<div class="zk-footer__col" data-reveal>
    <div class="zk-footer__col-title">${c.title}</div>
    <div class="zk-footer__links">${links}</div>
  </div>`;
}

function markup() {
  const enso = `<svg class="zk-footer__enso" viewBox="0 0 200 200" aria-hidden="true"><circle cx="100" cy="100" r="84" fill="none" stroke="#AE1F23" stroke-width="16" stroke-linecap="round" stroke-dasharray="464 700" transform="rotate(48 100 100)"/><circle cx="100" cy="100" r="64" fill="none" stroke="#AE1F23" stroke-width="8" stroke-linecap="round" stroke-dasharray="156 700" transform="rotate(202 100 100)"/></svg>`;
  const social = SOCIAL.map(([name, href, svg]) =>
    `<a href="${href}" target="_blank" rel="noopener" aria-label="${name}">${svg}</a>`).join('');
  return `
  <div class="zk-footer__glow" aria-hidden="true"></div>
  ${enso}

  <div class="zk-footer__grid">
    <div class="zk-footer__brand" data-reveal>
      <img class="zk-footer__logo" src="/zenkai-logo-blanco.webp" alt="Zenkai" width="2550" height="860" />
      <p class="zk-footer__tagline">En un año vas a tener un año más de experiencia. La pregunta es de qué.</p>
      <a class="zk-footer__cta" href="#pricing">Únete a Zenkai<svg width="13" height="13" viewBox="0 0 14 14" fill="none"><path d="M3 7h8M7 3l4 4-4 4" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg></a>
      <div class="zk-footer__social">${social}</div>
    </div>
    ${COLS.map(colHTML).join('')}
  </div>

  <div class="zk-footer__bottom" data-reveal>
    <div class="zk-footer__copy">© 2026 Zenkai. Todos los derechos reservados.</div>
    <div class="zk-footer__legal">
      <a href="/aviso-de-privacidad">Aviso de privacidad</a>
      <a href="/terminos-y-condiciones">Términos y condiciones</a>
      <span>Los precios ya incluyen IVA</span>
    </div>
  </div>`;
}

/**
 * Monta el footer dentro de `mount`.
 * @returns {HTMLElement} el <footer> montado.
 */
export function mountFooter(mount) {
  const footer = document.createElement('footer');
  footer.className = 'zk-footer';
  footer.setAttribute('role', 'contentinfo');
  footer.innerHTML = markup();
  (mount || document.body).appendChild(footer);

  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const revealEls = [...footer.querySelectorAll('[data-reveal]')];
  if (reduced) { footer.classList.add('is-in'); return footer; }

  footer.classList.add('is-fx');
  revealEls.forEach((el, i) => { el.style.transitionDelay = `${Math.min(i * 60, 360)}ms`; });
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) { footer.classList.add('is-in'); io.disconnect(); } });
    }, { threshold: 0.08 });
    io.observe(footer);
  } else {
    footer.classList.add('is-in');
  }

  return footer;
}
